<template>
  <div class="box1d">
    <div class="back" @click="$router.push('/box1')">
      <img src="@/assets/home/back.png" alt="" />
    </div>
    <!-- 底部小模型图片 -->
    <div class="bottImg">
      <div
        v-for="item in imgData"
        :key="item.bs"
        @click="$router.push(`/${item.path}`)"
        :class="{ active: item.active }"
      >
        <img :src="`img/${item.bs}.png`" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "box1d",
  components: {},
  data() {
    //这里存放数据
    return {
      imgData: [
        {
          bs: "1_1_1",
          path: "box1a",
        },
        {
          bs: "1_1_2",
          path: "box1b",
        },
        {
          bs: "1_1_3",
          path: "box1c",
        },
        {
          bs: "1_1_4",
          path: "box1d",
          active: true,
        },
        {
          bs: "1_1_5",
          path: "box1e",
        },
        {
          bs: "1_1_6",
          path: "box1f",
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.modelShow();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.box1d {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #073e5c;
  .back {
    z-index: 10;
    position: absolute;
    top: 20px;
    left: 20px;
    width: 40px;
    height: 23px;
    pointer-events: auto;
    touch-action: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bottImg {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: absolute;
    z-index: 10;
    bottom: 2px;
    left: 0;
    width: 100%;
    height: 20%;
    & > div {
      position: relative;
      width: 33%;
      height: 48%;
      text-align: center;
      & > img {
        height: 100%;
      }
    }
  }
  .active {
    pointer-events: none;

    & > img {
      border: 2px solid blue;
    }
  }
}
</style>